import { render, staticRenderFns } from "./CommunityProgressDetail.vue?vue&type=template&id=b6e39e70&scoped=true"
import script from "./CommunityProgressDetail.vue?vue&type=script&lang=js"
export * from "./CommunityProgressDetail.vue?vue&type=script&lang=js"
import style0 from "./CommunityProgressDetail.vue?vue&type=style&index=0&id=b6e39e70&prod&scoped=true&lang=css"
import style1 from "./CommunityProgressDetail.vue?vue&type=style&index=1&id=b6e39e70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e39e70",
  null
  
)

export default component.exports